import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Webform from "../views/Webform.vue";
import Confirm from "../views/Confirm.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/webform/:id/confirm",
    name: "confirm",
    component: Confirm,
    props: true
  },
  {
    path: "/webform/:id/:lang",
    name: "webform",
    component: Webform,
    props: true
  },
  {
    path: "/webform/:id",
    redirect: "/webform/:id/en"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
